module.exports = __webpack_public_path__ + "img/delete.031a6ed0.svg";